import { BASE_NETWORK, BASE_REOWN_CONFIG, BASE_SEPOLIA_NETWORK, ETHEREUM_NETWORK, USDT_FORCE_APPROVE_ADDRESSES } from './constants';
import { Environment, EnvironmentName, ReownAppKitNetworkConfig, type ReownEnvironmentConfig } from './models';

const REOWN_PROJECT_ID: string = '8cc1215260bcf297de114fe2467fb3af';
const REOWND_CONFIG: ReownEnvironmentConfig = { ...BASE_REOWN_CONFIG, projectId: REOWN_PROJECT_ID };
const NETWORKS: ReownAppKitNetworkConfig[] = [ETHEREUM_NETWORK, BASE_NETWORK, BASE_SEPOLIA_NETWORK];

export const environment: Environment = {
  production: false,
  envName: EnvironmentName.Stage,
  apiHost: 'https://stage-api.derefi.com/api/v1',
  useMocks: false,
  reown: REOWND_CONFIG,
  networks: NETWORKS,
  usdtForceApproveAddresses: USDT_FORCE_APPROVE_ADDRESSES,
};
